import React from 'react';
import { GuidelineForManipulation, GuidelineForm } from '../components/GuidelineForm';

export default function AddGuideline() {
  const defaultValues = {
    type: undefined,
    name: undefined,
    file: undefined,
    url: undefined,
    diseaseConditions: [
      {
        cancerTypeId: undefined,
        cancerPathologyId: undefined,
        cancerLocationId: undefined,
        sortOrder: 0,
      },
    ],
    assignAllOrganizations: false,
    organizations: [] as {
      label: string;
      value: string;
    }[],
  } as GuidelineForManipulation;

  return (
    <div className="h-2/3">
      <h1 className="ml-1 text-3xl font-semibold">Add Guideline</h1>
      <div className="py-3">
        <GuidelineForm defaultValues={defaultValues} />
      </div>
    </div>
  );
}
